import { Layer } from 'ui/components'
import { Page, PageFace } from 'ui/components/Page'

import { ReportBreadcrumbs } from '../../../components'
import { Actions, Filter, ReportTable } from './components'
import { ClientPortalReportContextProvider } from './context/contextProvider'

const ReportPage = () => (
  <ClientPortalReportContextProvider>
    <Page
      face={PageFace.PRIMARY}
      title={<ReportBreadcrumbs title="Client Portal Users Activity Report" />}
      actions={<Actions />}
    >
      <Layer rounded shadowed stretch>
        <Filter />
        <ReportTable />
      </Layer>
    </Page>
  </ClientPortalReportContextProvider>
)

export default ReportPage
